<div class="w-full h-full " [ngClass]="{'opacity-50': disabled} ">
  <div class="flex justify-between items-center mb-1 pl-[16px]" *ngIf="label || description">
    <label 
      *ngIf="label" 
      [for]="id" 
      [class]="getLabelClasses()"
    >
      {{ label }} <span *ngIf="required" [class]="getRequiredClasses()">*</span>
    </label>
    <span *ngIf="description" [class]="getDescriptionClasses()">{{ description }}</span>
  </div>
  
  <div class="relative">
    <div class="flex items-center absolute inset-y-0 left-0 pl-3 cursor-pointer" *ngIf="leftIcon">
      <NiIcon [class]="getIconClasses()" (onClick)="leftIconClick.emit( $event)" [icon]="leftIcon"></NiIcon>
    </div>
    
    <input
      [type]="type"
      [id]="id"
      [name]="name"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [required]="required"
      [attr.maxlength]="maxLength"
      [attr.autocomplete]="'off'"
      [class]="getInputClasses()"
      [ngStyle]="getInputStyles()"
      (input)="onInputChange($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />
    
    <div class="flex items-center  absolute inset-y-0 cursor-pointer right-0 pr-5" *ngIf="rightIcon || clearable && value">
      <button 
        *ngIf="clearable && value" 
        type="button" 
        [class]="getClearButtonClasses()"
        (click)="clearInput()"
      >
        ✕
      </button>
       <NiIcon [class]="getIconClasses()" (onClick)="rightIconClick.emit( $event)" [icon]="rightIcon"></NiIcon>
    </div>
  </div>
  
  <div class="mt-1 flex justify-between">
    <div [class]="getErrorClasses()" *ngIf="showError && error">{{ error }}</div>
    <div [class]="getHelperClasses()" *ngIf="maxLength">{{ value.length || 0 }}/{{ maxLength }}</div>
    <div [class]="getHelperClasses()" *ngIf="helperText && !(showError && error)">{{ helperText }}</div>
  </div>
</div>